var IPAddress='';
$(document).ready(function(e) {



  $.getJSON('https://api.ipinfodb.com/v3/ip-country/?key=25864308b6a77fd90f8bf04b3021a48c1f2fb302a676dd3809054bc1b07f5b42&format=json', function(data) {

    console.log(data.ipAddress);
    IPAddress=data.ipAddress;
  });

  function closePopup() {
    $('.popupOverlay .popupBox').removeClass('fadeInUp');
    $('.popupOverlay .popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
    $('.popupOverlay .cls_popup').remove();
    $('body').removeClass('popupOpned');

    if($('#manvideo').length) {
      $('#manvideo')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');   
    }
  }
  function openPopup(a) {
    $('.popupOverlay .popupBox').addClass('fadeInUp');
    $('.popupOverlay .popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
    $('body').addClass('popupOpned');
    $('.popupBox').append('<a class="cls_popup" ></a>');
  }

  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });

  //   $('.topbar a, .topbarPoupOpen').on('click', function(e){
  //     e.preventDefault();
  //     openPopup('topbarShipping');
  //   });


  $('.shippingInfoPopup').on('click', function(e){
    e.preventDefault();
    openPopup('smpassMoreInfo');
  });

  $('.afterpayLink').on('click', function(e){
    e.preventDefault();
    openPopup('afterpayPopup');
  });



  function refreshHeigh() {
    var bh = $('.cartButtonOuter').height()+80;
    var vh = window.innerHeight;
    var newh = vh-bh;
    var qih = $('.quick-items').height();
    $('.cartDrawer').removeClass('nofix');
    $('.quick-items').removeAttr('style');
    if(newh > 115) { // 115 is one line-item height in cart 
      if(qih > newh) {
        $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
      }
    }
    else {
      $('.cartDrawer').addClass('nofix');
    }
  }

  refreshHeigh();

  $(window).resize(function(){
    setTimeout(function() {
      refreshHeigh();
      $('.cartDrawer').css("height", window.innerHeight+'px');
    }, 50); 
  });
  
  if ($(window).width() > 991) {
    $(document).on({
      mouseenter: function() {
        $(".mainSections").addClass('menuHover');
        $('.site-nav').addClass('menuBg');
      },
      mouseleave: function() {
        $(".mainSections").removeClass('menuHover');
        $('.site-nav').removeClass('menuBg');
      }
    }, ".hasDropDown");
  }

  /* Site update+FVnext  */
  function scroll_stick_add_to_cart(){
    if($('.cutsom_button').length > 0 && (window.location.href.indexOf('is_sticky_atc=true') > -1 || window.sticky_add_to_cart == true)){
      $(".cutsom_button").removeClass("is-visible").removeClass("ProductStickyAddToCart");
      var scroll = $(window).scrollTop();

      var elemTop = $('.cutsom_button').offset().top;
      var elemBottom = elemTop + $('.cutsom_button').height();

      if (scroll >= elemBottom) {
        $(".cutsom_button").addClass("is-visible").addClass("ProductStickyAddToCart");
        if($(window).width() < 769){
          $('body').css("padding-bottom",$('.cutsom_button').outerHeight()+"px");
        }
      }
    }
  }

  scroll_stick_add_to_cart();

  $(window).scroll(function() {    
    scroll_stick_add_to_cart();
  });

  $window = $(window);
  $slick_slider = $('.proImgClrGroup');
  settings = {
    centerMode: false,
    arrows: false,
    dots: true, 
    autoplay: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  
  if ($window.width() <= 991) {
    $slick_slider.slick(settings);
  }
  $window.on('resize load', function () {
    if ($window.width() > 991) {
      if ($slick_slider.hasClass('slick-initialized')) {
        $slick_slider.slick('unslick');
      }
    } else if (!$slick_slider.hasClass('slick-initialized')) {
      return $slick_slider.slick(settings);
    }
  });
  
  $('body').on("click",'.closeZoom', function(){
    closeZoom();
  });

  $('body').on("click", function(e) {
    if ($(e.target)[0] != $('.zoomImgsCont')[0] || $(e.target)[0] != $('.zoom_element')[0]) {
      if ($(e.target)[0] == $('.zoomImgsWrap')[0]) {
        closeZoom();
      }
    }
  });
  
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      closeZoom();
    }
  });
  
  var closeZoom = function () {
    $('.zoomImgsWrap').remove();
    $('body').removeClass('ovfHidden');
    $('.mainImg').removeClass('current');
  }

  var pt = window.sm_theme.variable.product_title;
  $('.proImgClrGroup .featuredSlide .zoom_object').on("click",function(){
    $('.proImgClrGroup .featuredSlide .zoom_object').removeClass('current');
    $(this).addClass('current');
    $('body').addClass('ovfHidden');
    $('body').append('<div class="zoomImgsWrap"><div class="zoomimage_wrapper"><div class="zoomImgsCont"></div> <button class="closeZoom">X</button></div></div>');
    $(this).closest('.proImgClrGroup').find('.product-image:not(.slick-cloned) .zoom_object').each(function() {
      if ($(this).hasClass('type_image')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<img class="zoomTo zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+'" />');
        else
          $('.zoomImgsCont').append('<img class="zoom_element" src="'+$(this).attr('data-img')+'" alt="'+pt+'" />');
      } else if ($(this).hasClass('type_video')) {
        if($(this).hasClass('current'))
          $('.zoomImgsCont').append('<video class="zoomTo zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
        else
          $('.zoomImgsCont').append('<video class="zoom_element" playsinline="playsinline" muted="muted" autoplay="autoplay" loop="loop" preload="metadata" poster="'+$(this).parent().attr('data-img')+'"><source src="'+$(this).find('source').attr("src")+'" type="video/mp4"></video>');
      }
    });

    var imgs = $(".zoomImgsCont .zoom_element");
    var count = imgs.length;

    imgs.load(function() {
      count--;
      if (!count) {
        //setTimeout(function(){
        var s = $(".zoomImgsCont .zoom_element.zoomTo").position().top;
        $('.zoomImgsCont').animate({ scrollTop: s }, 1000);
        //},500);
      }
    }).filter(function() { return this.complete; }).load();

  });
  /* Site update+FVnext  */

  $('.dropdownmenu').each(function(){
    var lp = $(this).offset().left;
    if(lp < 0) {
      $(this).parent().addClass('rmPosRel');
    }
  });
  $('.hasDropDown').hover(function(){
    var d = $(this).find('.dropdownmenu');
    if(d.length) {
      var lp = d.offset().left;
      if(lp < 0) {
        $(this).addClass('pushtoLeft');
      } else {
        $(this).removeClass('pushtoLeft');
      }
      var rp = ($(window).width() - (d.offset().left + d.outerWidth()));
      if(rp < 0) {
        $(this).addClass('pushtoRight');
      } else {
        $(this).removeClass('pushtoRight');
      }
      /*if($(window).width() > 991) {

        $('ul.column-4').each(function(){
          if($(this).hasClass('lessContainer')) {
            var ss = $('#mainNavDesk > #AccessibleNav > li:first-child').offset().left;
            $(this).css('padding', '20px '+ss+'px');
          } else {
            var ss = $('header .container').offset().left;
            $(this).css('padding', '20px '+ss+'px');
          }
        });

        if($('ul.column-4').hasClass('lessContainer')) {
          var ss = $('#mainNavDesk > #AccessibleNav > li:first-child').offset().left;
          $('ul.column-4.lessContainer').css('padding', '20px '+ss+'px');
        } else {
          var ss = $('header .container').offset().left;
          $('ul.column-4.bigContainer').css('padding', '20px '+ss+'px');
        }

      }*/
    }    
  });

  $('body').on('click', '.mobileNav1', function(e){
    e.preventDefault();
    $('body').addClass('menuOpen');
    $('.fullPage').addClass('witmenu');
  });
  $('.filterToggle').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('filterOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });
   $('.closeFilter').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').removeClass('filterOpen');
      $('.fullPage').removeClass('witmenu');
    }, 50);
  });

  $('#mainNavMob').on('click','.toggleItem.level2',function(e){
 //   $('.mobileMenu').addClass('mobfoxheight');
 //   $('.mobileMenu')[0].scrollTop = 0;
    if($(this).hasClass('opend')) {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
    } else {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
      $(this).addClass('opend');
      $(this).parent().next('ul').addClass('toggleSubMenu');
    }

  });
  $('#mainNavMob').on('click','.backTitle',function(e){
    $('.toggleItem').removeClass('opend');
    $('.dropdownmenu').addClass('hideToggleMenu');
    setTimeout(function(){
      $('.dropdownmenu').removeClass('toggleSubMenu').removeClass('hideToggleMenu');
    },500);
    $('.mobileMenu').removeClass('mobfoxheight');
  });

  // $('#mainNavMob').on('click','.col_menu_only .menu_only_title',function(e){
  //   var h = $(this).closest('ul')[0].scrollHeight;
  //   $(this).closest('ul')[0].scrollTop = 0;
  //   $(this).closest('ul').css('overflow','hidden');
  //   $(this).next('ul').addClass('menu_step3'); //.css('min-height',h+'px');

  // });
 
  jQuery('#mainNavMob').on('click','.toggleItem.level3',function(e){
    jQuery(this).closest('li.col_menu_only').addClass('open_step3');
    jQuery(this).closest('ul.dropdownmenu').addClass('open_childofchild');
    localStorage.setItem("secondScroll", jQuery('.toggleSubMenu').scrollTop());
    jQuery(this).closest('ul.dropdownmenu')[0].scrollTop = 0;
  });
  jQuery('#mainNavMob').on('click','.backTitle3',function(e){
    jQuery(this).closest('li.col_menu_only').removeClass('open_step3');
    jQuery(this).closest('ul.dropdownmenu').removeClass('open_childofchild');
    jQuery(this).closest('ul.dropdownmenu')[0].scrollTop = localStorage.getItem("secondScroll");
  });
  
  // $('#mainNavMob').on('click','.backTitle3',function(e){
  //   var btn = $(this);
  //   btn.closest('.toggleSubMenu').removeAttr('style');
  //   btn.closest('ul').addClass('hidemenu_step3');
  //   setTimeout(function(){
  //     btn.closest('ul').removeClass('menu_step3').removeClass('hidemenu_step3');
  //   },500);
  // });

  $('body').on('click','.openThird',function(e){
    e.preventDefault();
    var btn = $(this);
    btn.closest('.hasThird').removeAttr('style');
    btn.closest('.hasThird').addClass('thirdNavOpen');
  });
  
  $('body').on('click','.hasThird h4',function(e){
    e.preventDefault();
    var btn = $(this);
    btn.closest('.hasThird').removeClass('thirdNavOpen');
  });

  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
    if($(this).closest('.colSidebar').length) {
      return false;
    }
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });

  $('.menu-overlay').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
  });



  $('.mobToggler').on('click',function(e){
    $(this).next('div').slideToggle();
    $(this).toggleClass('opned');
  });
  window.onload = function() {
    $('.full_banner').each(function(){
      var img = $(this).attr('data-banner');
      $(this).css('background-image','url('+img+')');
      $(this).find('img').attr('src',img);
    });
    if($(window).width() <= 991) {
      $('.afterLoad').each(function(){
        var img = $(this).attr('data-src');
        $(this).attr('src', img);
      });
    }
  };

  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('.update_data_1').html($(data).find('.update_data_1').html());
      $('.update_data_2').html($(data).find('.update_data_2').html());
      $('#crt').removeClass('loading');

      setTimeout(function() {
        refreshHeigh();
        $('.cartDrawer').css("height", window.innerHeight+'px');
      }, 100); 
      //Currency.convertAll(shopCurrency, $('.currentCurreny > span').text());
      //jQuery('.currentCurreny > span').text(Currency.currentCurrency); 
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });
  }

  $('.cartOuter').on('mouseenter, click',function(e){
    if($(this).find('.cartCount').text()!="0") {
      //addToCartSuccess();
      e.preventDefault();
      setTimeout(function(){
        $('body').addClass('cartOpen');
        $('.fullPage').addClass('witmenu');
      }, 50);
    }
  });



  // $('.cartCount').on("DOMSubtreeModified",function(){
  //   addToCartSuccess();
  // });



  $('body').on('click','.addtocart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.val('Adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        if(jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        }
        btn.val('Add to my basket');
        btn.removeAttr('disabled');
      },
      success: function(product) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "addToCart",
          addToCart: {products: product},
        });
//         var _learnq = _learnq || [];
//         var item = {
//           Name: product.product_title,
//           ProductID: product.product_id,
//           ImageURL: product.image,
//           URL: window.location.href,
//           Brand: product.vendor,
//           Price: product.price/100
//         };
//         _learnq.push(['track', 'Added to Cart', item]);
      }
    }).done(function( data ) {
     
      
      addToCartSuccess();
      btn.val('Add to my basket');
      btn.removeAttr('disabled');
      // QUICK SHOP
      if (btn.hasClass('quickAdd')) {
        $('.product_quickview, .overlay').removeClass('active');
        $('body').removeClass('Fixed');
      }
      // QUICK SHOP
      $.getJSON('/cart.js', function(c){
        $('.cartCount').text(c.item_count);
      });
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });

  });

  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount, .cartCount').text(c.item_count);
      if(!c.item_count) {
        $('.itemCount').text('0');
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
      } else {
        addToCartSuccess();
      }
    });
  });

  $('body').on('click', '.quick-cart-details .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    if (!$(this).hasClass('upsell_qty')) {
      $('#crt').addClass('loading');
      var id = parseInt(input.attr('data-id'));
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: 'updates['+id+']='+ip,
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          alert(response.description);
          $('#crt').removeClass('loading');
        },
        success: function(){
          addToCartSuccess();
          $.getJSON('/cart.js', function(c){
            $('.itemCount, .cartCount').text(c.item_count);
          });
          $('#crt').removeClass('loading');
        }
      });
    }
  });

  $('.item-quantityg').keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  });

  $('.tablist ul li').click(function(e){
    if(!$(this).parents('.tablist').hasClass('tablist_404')){
      e.preventDefault();
      $('.tablist ul li').removeClass('activetab');
      $('.relatedProductC').hide();
      var currenTab = $(this).data('id');
      $(this).addClass('activetab');
      $('#'+currenTab).show();
      //var x = $(this).attr('data-slick');
      if($('.responsive').hasClass('slick-initialized')) {
        $('.responsive').slick('refresh');
      }
    }
  });


  $('.responsive').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  if($('#myVideo').length) {
    document.getElementById("myVideo").pause();
  }
  $(".fancybox_viral").click(function(event){
    event.preventDefault();
    document.getElementById("myVideo").play();
    $('.viralsweep_popup').addClass('open_viralpopup');
    $('body').addClass('open_viralpopupbody');
    $('html').addClass('open_viralpopuphtml');
  });
  $(".inner_viral_close").click(function(event){		
    event.preventDefault();
    document.getElementById("myVideo").pause();
    $('.viralsweep_popup').removeClass('open_viralpopup');
    $('body').removeClass('open_viralpopupbody');
    $('html').removeClass('open_viralpopuphtml');
  });

  var baseURL = "https://services.superga-usa.com/";


  $('.phoneInput').on('keyup change paste', function(){
    if($(this).val().trim() == '') {
      $('.checkphone').closest('label').addClass('disable');
      $(".checkphone").prop("checked", false);
      $('.checkphone').attr('disabled','disabled');
      $('.homeModalSubmit').removeAttr('disabled');
    } else {
      $('.checkphone').closest('label').removeClass('disable');
      $('.checkphone').removeAttr('disabled');
      $('.homeModalSubmit').attr('disabled','disabled');
    }
  });

  $('.checkphone').on('change', function(){
    if($(this).is(':checked')) {
      $(".homeModalSubmit").removeAttr('disabled');
    } else {
      $(".homeModalSubmit").attr('disabled','disabled');
    }
  });

  $('.homeModalNL').on('submit',function(e){
    // This prevents the form from submitting
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
    //     debugger;
    var form = $(this);
    var cbv = form.find('.checkphone').is(':checked');

    var submitbtn = form.find('.homeModalSubmit');

    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
      return false;
    } else {
      em.parent().find('.err-msg').remove();
    }
    var pf = form.find("input[type='tel']");
    var phone = form.find("input[type='tel']").val().trim();
    var phoneno = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    if(pf.hasClass('req') || phone != '') {
      if(phone == '' || !phoneno.test(phone)) {
        pf.parent().append('<p class="err-msg">Please enter valid phone number.</p>');
        x = false;
        return false;
      } else {
        pf.parent().find('.err-msg').remove();
      }
    }    

    var ppv = form.find("input[name='version']").val();
    var ts = new Date();
    if(x){

      submitbtn.attr('disabled','disabled');


      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/subscriptions/external/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": "Q9ADrq",
          "$fields": "$source,LOYALTY_MEMBER,SM_ACCOUNT,$phone_number,Mobile Opt In,$consent,$consent_id,$consent_method,$consent_timestamp",
          "email": email,
          "$source": "Homepage Popup",
          "LOYALTY_MEMBER": "True",
          "SM_ACCOUNT": "N",
          "Mobile Opt In": cbv,
          "$phone_number": phone,
          "$consent": ["Email", "SMS"],
          "$consent_id": "popup"+ppv,
          "$consent_method": "Homepage Popup",
          "$consent_timestamp": ts
        }
      };
      console.log(settings);
      console.log(IPAddress);
      //debugger;
      // use ajax to sign the user up
      $.ajax(settings).done(function(response){
        //debugger
        console.log(response);
      }).fail(function(jqXHR, textStatus, error){
        // for failure let's identify the user because they're already subscribed
        // debugger
        var klaviyo_identify = {
          "token" : "P8MJR3",
          "properties" : {
            "$email" : email,
            "Mobile Opt In": cbv,
            "$consent": ["Email", "SMS"],
            "$consent_id": "popup"+ppv,
            "$consent_method": "Homepage Popup",
            "$consent_timestamp": ts,
            "ip address": IPAddress      
          }
        };
        var klaviyo_json = btoa(JSON.stringify(klaviyo_identify));
        console.log(klaviyo_json);
        $.get("https://a.klaviyo.com/api/identify?data=" + klaviyo_json);
      });
      // debugger

      $.ajax({
        type: "POST",
        url: 'https://api.postscript.io/api/subscriber/add',
        data: { 'email_address' : email, 'phone' : phone},
        headers : { 'Authorization': 'ZT7SFFT2Z90DJ5YUHER79CNKE6WJC4128CRS9E5XWLG1TVSWQQVHFCVNPFE7EGFX' },
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          $('section.modal.homepage-modal').css('background','#000');
          form.hide();

          if(cbv) {
            form.closest('.modal > div').html('<div class="popTitle text-center successmessg"><h2>THANKS FOR JOINING!</h2> <p>You’ll receive a text message with your promo code shortly.</p> <a href="#" class="closemodal banner_button">START SHOPPING</a></div>');
          } else {          
            form.closest('.modal > div').html('<div class="popTitle text-center successmessg"><h2>THANKS FOR JOINING!</h2> <p>You’ll receive an email with your promo code shortly.</p> <a href="#" class="closemodal banner_button">START SHOPPING</a></div>');
          }


          //$('.successMsg').remove();
          //form.parent().append("<span class='successMsg'>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");
          //$('.nlMore input[type="email"]').val(email);
          //openPopup('nlMsg');
        },
        error: function (e) {
          //debugger;
          form.append('<p class="err-msg">Please try after some time!</p>');
          submitbtn.removeAttr('disabled');
        }
      });


    }
  });


  $('body').on('click','.closemodal', function(e){
    e.preventDefault();
    $.modal.close();
  });


  $('#moreAboutYou').on('submit',function(e){
    e.preventDefault();    
    var x = true;
    $('.err-msg').remove();
    var form = $(this);
    var email = form.find("input[type='email']").val().trim();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }

    if($('#agreementSMPass:checked').length) {
      var pc = form.find("input[name='pcode']");
      if(pc.val().trim() == '') {
        pc.parent().append('<p class="err-msg">Please enter Postal code.</p>');
        x = false;
      } else {
        pc.parent().find('.err-msg').remove();
      }

      var tp = form.find("input[name='telephone']");
      if(tp.val().trim() == '') {
        tp.parent().append('<p class="err-msg">Please enter Telephone.</p>');
        x = false;
      } else {
        tp.parent().find('.err-msg').remove();
      }
    }

    if(x){
      var mydata={
        email: email,
        page:"Footer"
      };
      $.ajax({
        type: "POST",
        url: baseURL + '*********',
        data: mydata,
        dataType: "json",
        crossDomain: true,
        success: function (json) {
          //debugger;
          console.log(json);
          form.hide();
          form.parent().append("<span>Thanks! Please confirm your subscription to our mailing list via the email we just sent you :)</span>");

        },
        error: function (e) {
          form.append('<p class="err-msg">Please try after some time!</p>');
        }
      });
    }
  });

  $('#shopify-section-footer a').each(function(){

    if($(this).html() == 'Accessibility Toolbar'){
      $(this).attr('id', 'accessibilityEnablerCustomTrigger');
    }

  });

});

$(document).mouseup(function(e){
  var container = $('.inner_viral');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".viralsweep_popup").removeClass('open_viralpopup');
    $("body").removeClass('open_viralpopupbody');
    if($('#myVideo').length) {
      document.getElementById("myVideo").pause();
    }
  }
});


$(window).load(function() {

  function klaviyoAPI(first_name, last_name, email, source, flag, form,SM_ACCOUNT){

    // Klaviyo Newsletter live list id
    var list_id = 'Q9ADrq';  
    // staging id
    // var list_id = 'Lhj55e';
   

    var settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/subscriptions/external/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      "data": {
        "g": list_id,
        "$first_name": first_name,
        "$last_name": last_name,
        "email": email,
        "$fields": "$source, $first_name, $last_name",
        "$source": source
      },
      error: function(data, errorThrown) {
        $('.error').remove();
        if(data.statusText == "BAD REQUEST") {
          form.parent().append('<p class="error">The email already subsribed!</p>');
        }
        
      }
    };

    //debugger;
    if(flag == 1){
      settings['data']['$fields'] = "$source, LOYALTY_MEMBER, SM_ACCOUNT, $first_name, $last_name";
      settings['data']['LOYALTY_MEMBER'] = "True";
      settings['data']['SM_ACCOUNT'] = SM_ACCOUNT;
    }
    if(flag == 0){
      settings['data']['$fields'] = "$source, LOYALTY_MEMBER, SM_ACCOUNT, $first_name, $last_name";
      settings['data']['LOYALTY_MEMBER'] = "True";
      settings['data']['SM_ACCOUNT'] = "True";
    }


    $.ajax(settings).done(function (response) {

      form.hide();
      form.parent().append('<p style="text-align:center;">You \'re in!</p>');      
      
      
    });
    

  } 

  $('#create_customer').on('submit',function(event) {

    var x = true;
    $(this).find('.err-msg').remove();
    var fn = $(this).find('#first_name');
    var em = $(this).find('#email');
    var ln = $(this).find('#last_name');
    var ps = $(this).find('#password');
    var form = $(this);
    
    if(fn.val().trim() == ''){
      fn.addClass('inputerror');
      fn.parent().append('<p class="err-msg">Please enter first name.</p>');
      x = false;
    } else {
      fn.removeClass('inputerror');
      fn.parent().find('.err-msg').remove();
    }

    if(ln.val().trim() == ''){
      ln.addClass('inputerror');
      ln.parent().append('<p class="err-msg">Please enter last name.</p>');
      x = false;
    } else {
      ln.removeClass('inputerror');
      ln.parent().find('.err-msg').remove();
    }

    if(ps.val().trim() == ''){
      ps.addClass('inputerror');
      ps.parent().append('<p class="err-msg">Please enter password.</p>');
      x = false;
    } else {
      ps.removeClass('inputerror');
      ps.parent().find('.err-msg').remove();
    }

    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.addClass('inputerror');
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.removeClass('inputerror');
      em.parent().find('.err-msg').remove();
    }
    if(x==false) {
      return false;
    }
    else {
      //this will prevent the default submit
      event.preventDefault(); 
      form.parent().append('<p style="text-align:center;">Thanks for joining.</p>'); 
      
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": "PH7ERm",
          "$fields": "jQuerysource,Account OptIn",
          "email": em.val(),
          "jQuerysource": "Register",
          "Account OptIn": $('#marketing').is(':checked')
        }
      };
      var form = $(this);

      jQuery.ajax(settings).done(function(){
        
        var source = 'Account Creation';
        var flag = 0;

       // klaviyoAPI(fn.val(), ln.val(), em.val(), source, flag, form,"Y");
        setCookie("RegisterEmail",email,365);
        custom_Registeration(em.val(),fn.val(),ln.val());

        form.unbind('submit').submit();
      });
    }
  });
 
  var custom_Registeration = function(email,first_name,last_name){
    if($("#marketing").prop("checked")){
      var mydata={
        email: email,
        page:"Registeration",
        newsletter:"on", 
        first_name:first_name,
        last_name:last_name
      };
    }
  };
  
  var setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }; 
  
  $('#click-1').click(function(event) {

    console.log('ap button click 1');

    if( $('#Name').val() != "" ){

      $('#popup-header-2').css('display', 'inline-block');      
      $('#click-2').css('display', 'inline-block');


      $('#popup-header-1').hide();
      $('#click-1').hide();

      //         $('.mainNewsletter').attr('id', 'homeNL');

    }else{

      $('.err-msg_header_name').html('Please enter your name.');
      $('p.err-msg_header_name').show();
      //       console.log('name empty');
    }

  });

  // header newsletter
  $('#click-2').click(function(event) {

    console.log('header email submit');
    event.preventDefault();
    // get the first and last name ----------
    var myStr = $("#Name").val();
    var email = $("#Email").val();
    var source = 'Site Signups (Header)';

    if( email == "" ){
      $('.err-msg_header_email').html('Please enter email.');
      $('p.err-msg_header_email').show();

    }else{

      var form = $(this);
      // console.log(myStr);
      var strArray = myStr.split(" ");
      var first_name = strArray[0];
      var last_name = '';
      // Display array values on page
      for(var i = 1; i < strArray.length; i++){
        if(i==1){
          last_name = strArray[i];
        }else{
          last_name = last_name + ' ' + strArray[i];
        }

      }
      // flag is for identifing for newsletter or signup
      // 1 is for newsletter
      // 0 for signup
      var flag = 1;

      // hide the form on api call
      form.hide();
      $("#Email").hide();
      $(".err-msg_header_email").hide();


      klaviyoAPI(first_name, last_name, email, source, flag, form,"N");
    }



  });

  $('#clickpopup-1').click(function(event) {

    if( $('#flName').val() ){

      $('#modalEmailInput').css('display', 'inline-block');      
      $('.button-submit').css('display', 'inline-block');
      $('#modal-newsletter input.newsletter__input').hide();
      $('#clickpopup-1').hide();
      $('#modal-newsletter p.err-msg2').hide();        

    }else{

      $('#modal-newsletter .err-msg2').html('Please enter your name.');
      $('#modal-newsletter p.err-msg').show();
      // console.log('name empty');
    }

  });

  // popup newsletter
  $('#modal-newsletter').submit(function(event) {

    //this will prevent the default submit
    event.preventDefault(); 
    var form = $(this);
    var x = true;
    $('.err-msg').remove();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
    } else {
      em.parent().find('.err-msg').remove();
    }

    if(x){

      // get the first and last name ----------
      var myStr = $("#flName").val();
      // console.log(myStr);
      var strArray = myStr.split(" ");
      var first_name = strArray[0];
      var last_name = '';
      // Display array values on page
      for(var i = 1; i < strArray.length; i++){
        if(i==1){
          last_name = strArray[i];
        }else{
          last_name = last_name + ' ' + strArray[i];
        }

      }

      var email = $("#modalEmailInput").val();
      var source = 'Homepage Popup';
      // flag is for identifing for newsletter or signup
      // 1 is for newsletter
      // 0 for signup
      var flag = 1;
      klaviyoAPI(first_name, last_name, email, source, flag, form,"N");
    }

  });

  // footer newsletter
  $('#footerNewsletter').submit(function(event) {

    //this will prevent the default submit
    event.preventDefault(); 
    $('.error').remove();
    var email = $("#footer-email").val();
    var source = 'Site Signups (Footer)';
    var form = $(this);
    var x = true;
    $('.err-msg').remove();
    var em = form.find('input[type="email"]');
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.parent().append('<p class="err-msg">Please enter valid e-mail.</p>');
      x = false;
      return false;
    } else {
      em.parent().find('.err-msg').remove();
      
      
//       $('.successEmail').val(email);
//       $('.popupOverlay2 .popupBox').addClass('fadeInUp');
//       $('.popupOverlay2 .popupBox').removeClass('slideOutUp');
//       $('.popupOverlay2.footerSuccss').fadeIn('slow');
//       $('body').addClass('popupOpned2');
      
    }
 

  });

  $('body').on('click','.footer_cls_popup',function(e){ // this is only for footer success popup close 
    e.preventDefault();
    $('.popupOverlay2 .popupBox').removeClass('fadeInUp');
    $('.popupOverlay2 .popupBox').addClass('slideOutUp');
    $('.popupOverlay2').fadeOut('slow');
    $('body').removeClass('popupOpned2');
    
    var source = 'Site Signups (Footer)';
    var form = $('#footerNewsletter');
    var email = form.find("#footer-email").val();
    var flag = 1;
    var first_name = '';
    var last_name = '';
    klaviyoAPI(first_name, last_name, email, source, flag, form,"N");
    
    console.log(email);
    
  });

$('body').on('click','.single-qty .qty-btn', function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    console.log(ip, 'before');
    if($(this).hasClass('plus-symbol')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    console.log(ip, 'after');
    input.val(ip);
  }); 
  
  function addtocart(){
    $.get('/cart',function(data){
      var html = $(data).find('.cart-details').html();
      $('.cart-details').html(html);
    });
  }
  $('body').on('click','.btnadd',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.val('Adding...');
    $.ajax({
      type : 'POST',
      url : '/cart/add.js',
      data :form.serialize(),   
      dataType: 'json',
      error : function(jqXHR, textStatus, errorThrown){        
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut(); 
        $('#load-spinner').removeClass('loader');
      },
      success : function(){
        addtocart();
        $.getJSON('/cart.js', function(c){
          $('.cartCount').text(c.item_count);
        });
      }
    });
  });

 
  
});


$(document).ready(function(){
  function review_scroll(){
    if($('#reviews').outerHeight() > 0){
      $('html,body').animate({
        scrollTop: $('#reviews').offset().top
      }, 2000);
      return;
    }else{
      setTimeout(function(){
        review_scroll();
      },1000);
    }
  }
  var url = window.location.hash;
  if (url == '#reviews'){
    review_scroll();
  }
  
   $('body').on('click',".review_a .text-m",function(e){
    e.preventDefault();
    window.location = $(this).closest('.review_a').attr('href');
  });
  
  
  function setCookie(cname,cvalue,exdays) {
     const d = new Date();
     d.setTime(d.getTime() + (exdays*24*60*60*1000));
     let expires = "expires=" + d.toUTCString();
     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
   }


  
   function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  
     var c = 0; 
  function find_teaser(){
    if($('.kl-teaser-TzYk2v').length > 0){
      if(getCookie("teaser_closed") != 'yes'){
        $('.kl-teaser-TzYk2v').parent().append('<div class="close klaviyo_teaser_close">x</div>');
      }else{
        $('.kl-teaser-TzYk2v').css("top","unset");
      }
      return;
    } else{
      if (c < 20){
        setTimeout(function(){
          find_teaser();
        },1000);
        c++;
      }else{
        return;
      }
    }
  }
  
  find_teaser();

  $('body').on("click",".close.klaviyo_teaser_close",function(e){
    $(this).hide().parent().find('.kl-teaser-TzYk2v').css("top","unset");
    setCookie("teaser_closed","yes");
    $('.klaviyo_teaser_close').remove();
  });
  
  $('body').on("click",".klaviyo-close-form",function(){
    find_teaser();
  });
  
  $('body').on("click","button.kl-teaser-TzYk2v.needsclick",function(){
    $('.klaviyo_teaser_close').remove();
  });

  $(".shoeGlossary .head-links a").click(function(){
    if(!$(this).hasClass('inactive-link')&&!$(this).hasClass('selected'))
    {
      $(".head-links a").each(function(){
        $(this).removeClass('selected');
      })

      $(this).addClass('selected');

      var y = $(this).attr("id");

      if($(this).hasClass('all')){
        $('.toggle-item').each(function(){
          if(!$(this).hasClass('inactive')){
            $(this).css('display','block');
          }
        })
        $('.back-to-top').css('display','inline');
      }else{
        $('.back-to-top').css('display','none');
        $('.toggle-item').each(function(){
          if($(this).hasClass('toggle-item-'+y)){
            $(this).css('display','block');
          }else{
            $(this).css('display','none')
          }
        })
      } 

    } 
    return false;
  });

  $('.shoeGlossary .back-to-top a').click(function(){
    $('html, body').animate({
      scrollTop: $("#cachedTC_TCArea_1").offset().top
    }, 500);
  })

       /* maddenqood page*/
   $(window).scroll(function () { 
     if($('.maddenwood_header_section').length > 0){
      var scroll = $(window).scrollTop();
      if (scroll >= 200) {
          $(".maddenwood_header_right").addClass("maddenwood_header-sticky");
      } else {
          $(".maddenwood_header_right").removeClass("maddenwood_header-sticky");
      }
     }
 });    

    $('.paloma-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        dots: true,
        adaptiveHeight: true
    });

  if($(window).width() <= 991){
    var video_class = 'video.mobile_imgonly';
  } else{
    var video_class = 'video.desktop_imgonly';
  }
    //play button
    $("body").on('click','.main-btn.maddenwood_play_btn',function (e) {
      e.preventDefault();
        $(this).closest('.maddenwood_hero_section').find(".main-popup").toggleClass("active");
        $('body,html').toggleClass('scrollno');
        var get_video = $(this).closest('.maddenwood_hero_section').find(video_class)[0];
        if (get_video.paused){
          get_video.muted = false;
          get_video.play();
        }              
    });
    $("body").on("click",'.maddednwooed_popup .close-menu',function (e) {
      e.preventDefault();
        $(".main-popup").removeClass("active");
        $('body,html').removeClass('scrollno');
        var get_video = $(this).closest('.maddenwood_hero_section').find(video_class)[0];            
        get_video.muted = true;
        get_video.pause();                
    });
  
  // Quick Shop Start
  $('body').on('click', '.close-quick, .overlay', function(e) {
    var getProductData = JSON.parse($(this).parents('.main-quick').find('[type="application/json"].quick').text());
    $('.product_quickview, .overlay').removeClass('active');
    $('body').removeClass('Fixed');
    $('.product_quickview').empty();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quick_view_close',
      quickviewProduct: getProductData,
      _clear: true,
    });
  });

  $('body').on('click', '.main-quick .select_color .swatch-element a', function (e) {
    e.preventDefault();
    var product_handle = $(this).attr('href');
    getProductData(product_handle, e);
  });
  // Quick Shop End
  
});